import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-886c2034")

_pushScopeId("data-v-886c2034")
const _hoisted_1 = { class: "loading-dialog-content" }
const _hoisted_2 = { class: "content-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_custom_dialog = _resolveComponent("custom-dialog")

  return (_openBlock(), _createBlock(_component_custom_dialog, {
    modelValue: _ctx.isVisible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isVisible = $event)),
    title: _ctx.title,
    onClose: _ctx.closeDialog
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("p", _hoisted_2, _toDisplayString(_ctx.content), 1),
        _createVNode(_component_svg_icon, {
          "data-test": "loading",
          name: "icon-import-loading",
          class: "rotate",
          color: "color-primary",
          fontSize: "32px"
        })
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title", "onClose"]))
})